"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueTypeToFriendly = void 0;
const ValueTypeToFriendly = (val) => {
    return val
        .split("_")
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(" ");
};
exports.ValueTypeToFriendly = ValueTypeToFriendly;
